module.exports = __webpack_public_path__ + "static/media/CNX-CNX-50-iQ.917a1574.png";